// extracted by mini-css-extract-plugin
export default {"navigation":"Navigation_navigation__cxrZp"};